import { apiFetch } from '../lib/apiFetch';

export interface StaffOption {
  id: string;
  name: string;
}

const DEFAULT_LIMIT = 50;

/** Active users by name, for pickers. A blank search lists the first page. */
export async function fetchStaffOptions(
  search: string,
  limit: number = DEFAULT_LIMIT,
): Promise<StaffOption[]> {
  const qs = new URLSearchParams();
  if (search.trim()) qs.set('search', search.trim());
  qs.set('limit', String(limit));
  const res = await apiFetch(`/api/v1/staff/options?${qs.toString()}`);
  if (!res.ok) throw new Error(`Failed to fetch users: ${res.status}`);
  const data = (await res.json()) as { users: StaffOption[] };
  return data.users;
}
